import React, { FC, useContext } from 'react'

import { clsx } from 'clsx'
import { Controller, useFormContext } from 'react-hook-form'

import { AppContext } from 'Const'

import ErrorMessage from 'Components/ErrorMessage'
import PhoneInput from 'Components/PhoneInput'

import FormErrors from '../../../FormErrors'

interface Props {
  disabled?: boolean
  submitting?: boolean
}

const Phone: FC<Props> = ({ disabled, submitting }) => {
  const { control, errors } = useFormContext()
  const { locationCountryIsoCodes } = useContext(AppContext)
  const defaultCountry = locationCountryIsoCodes[0] || 'US'
  const continueLabel = submitting ? 'Verifying' : 'Continue'

  return (
    <div className="position-relative d-flex flex-column align-items-start mb-2 checkout-contact-flow__field-group">
      <label className="sr-only" htmlFor="customer-phone">
        Please enter your phone number
      </label>
      <Controller
        control={control}
        name="phone"
        render={(props) => (
          <div className="checkout-contact-flow__phone-submit-row">
            <PhoneInput
              {...props}
              required
              addInternationalOption={false}
              autoComplete="tel"
              countryOptionsOrder={locationCountryIsoCodes}
              defaultCountry={defaultCountry}
              disabled={disabled}
              id="customer-phone"
              numberInputProps={{ className: 'form-control' }}
              placeholder="Enter your phone number"
            />
            {!disabled ? (
              <button
                aria-label={continueLabel}
                className={clsx('btn btn-accent checkout-contact-flow__phone-submit-btn', { btn_loading: submitting })}
                disabled={submitting}
                type="submit"
              >
                {continueLabel}
              </button>
            ) : null}
          </div>
        )}
        rules={{ required: 'Phone is required' }}
      />
      {disabled ? (
        <span aria-hidden="true" className="checkout-contact-flow__phone-lock">
          <svg fill="none" height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg">
            <path
              clipRule="evenodd"
              d="M5 4.63601C5 3.76031 5.24219 3.1054 5.64323 2.67357C6.03934 2.24705 6.64582 1.9783 7.5014 1.9783C8.35745 1.9783 8.96306 2.24652 9.35823 2.67208C9.75838 3.10299 10 3.75708 10 4.63325V5.99999H5V4.63601ZM4 5.99999V4.63601C4 3.58148 4.29339 2.65754 4.91049 1.99307C5.53252 1.32329 6.42675 0.978302 7.5014 0.978302C8.57583 0.978302 9.46952 1.32233 10.091 1.99162C10.7076 2.65557 11 3.57896 11 4.63325V5.99999H12C12.5523 5.99999 13 6.44771 13 6.99999V13C13 13.5523 12.5523 14 12 14H3C2.44772 14 2 13.5523 2 13V6.99999C2 6.44771 2.44772 5.99999 3 5.99999H4ZM3 6.99999H12V13H3V6.99999Z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </svg>
        </span>
      ) : null}
      <ErrorMessage as={FormErrors} errors={errors} name="phone" />
    </div>
  )
}

export default Phone
